const FileCache = {
  get(fileName, callback) {
    window.resolveLocalFileSystemURL(cordova.file.dataDirectory, dirEntry => {
      dirEntry.getFile(fileName, { create: false }, callback);
    });
  },
  remember(url, fileName = null) {
    if (!fileName) {
      let parts = url.split('/');
      fileName = parts[parts.length-1];
    }

    window.resolveLocalFileSystemURL(cordova.file.dataDirectory, dir => {
      this.fetchFile(dir, url, fileName);
    }, this.onErrorLoadFs);
  },
  fetchFile(dirEntry, remoteUrl, fileName) {
    axios({
      url: remoteUrl,
      method: 'GET',
      responseType: 'blob'
    }).then(({data}) => {
      this.cacheFile(dirEntry, data, fileName);
    });
  },
  cacheFile(dirEntry, fileData, fileName) {
    dirEntry.getFile(fileName, { create: true, exclusive: false }, fileEntry => {
      this.writeFile(fileEntry, fileData);
    }, this.onErrorCreateFile);
  },
  writeFile(fileEntry, dataObj, isAppend) {
    fileEntry.createWriter(fileWriter => {
      fileWriter.onerror = function(e) {
        console.log("Failed file write: " + e.toString());
      };

      fileWriter.write(dataObj);
    });
  },
  onErrorLoadFs(err) {
    console.log('onErroloadFs', err)
  },
  onErrorCreateFile(err) {
    console.log('onErrorCreateFile', err)
  },
  onErrorReadFile(err) {
    console.log('onErrorReadFile', err)
  }
};

export default FileCache;
